import React from 'react';

import type { PopoverPosition } from '@mui/material';
import { DeclarativeContextMenu } from 'src/components/declarative-menu';

import { useDocumentContextMenu } from './use-document-context-menu';

export type ContextMenuLocation = PopoverPosition | null;

interface DocumentContextMenu {
  location: ContextMenuLocation;
  setLocation: (location: ContextMenuLocation) => void;
}

export function DocumentContextMenu({
  location,
  setLocation,
}: DocumentContextMenu): JSX.Element | null {
  function handleClose(): void {
    // `setTimeout` to give renderModel time to finish updating before re-rendering.
    setTimeout(() => setLocation(null));
  }

  if (!location) return null;

  return <OpenDocumentContextMenu location={location} onClose={handleClose} />;
}

interface OpenDocumentContextMenuProps {
  location: PopoverPosition;
  onClose: () => void;
}

function OpenDocumentContextMenu({ location, onClose }: OpenDocumentContextMenuProps): JSX.Element {
  const config = useDocumentContextMenu();

  return <DeclarativeContextMenu config={config} position={location} onClose={onClose} />;
}
